import { FormInstance } from 'antd';
import { FieldContext } from 'rc-field-form';
import { useContext, useEffect } from 'react';

import Form from '../components/Form';
import usePrevious from './usePrevious';

/** Esse hook é feito para generalizar um componente de form, tornando possível a utilização em diferentes forms (veja o exemplo do `components/EmailForm.tsx`), portanto se estiver fazendo um form que só será utilizado em um lugar usar a prop `onChange` do componente provavelmente já será o suficiente. */

const useOnChangeField = <T>(
  fieldName: string | (number | string)[],
  callback: (
    fieldValue: T,
    prevFieldValue: T,
    form: FormInstance,
    contextNamePrefix: (number | string)[]
  ) => void
) => {
  const form = Form.useFormInstance();
  const fieldContext = useContext(FieldContext);
  const fieldValue = Form.useWatch(fieldName, form);
  const prevFieldValue = usePrevious(fieldValue);

  useEffect(() => {
    if (fieldValue !== prevFieldValue) {
      callback(fieldValue, prevFieldValue, form, fieldContext.prefixName ?? []);
    }
  }, [callback, fieldContext.prefixName, fieldName, fieldValue, form, prevFieldValue]);
};

export default useOnChangeField;
